/* Expenses API client — Phase 5 Bundle B
 *
 * UI shape: month-keyed object
 *   expenses["April 2026"] = [{ id, title, amount }, ...]
 *
 * API shape: flat with month field
 */
import { api } from "./api";
import { monthLabelToYM } from "./attendanceApi";

const BASE = "/expenses";

export function expenseApiToUi(r) {
  return {
    id: r.id,
    title: r.title,
    amount: r.amount != null ? String(r.amount) : "0",
    category: r.category || null,
    note: r.note || "",
  };
}

export const expensesApi = {
  async listByMonth(monthLabel) {
    const month = monthLabelToYM(monthLabel);
    if (!month) return [];
    const rows = await api.get(`${BASE}?month=${encodeURIComponent(month)}`);
    return (Array.isArray(rows) ? rows : []).map(expenseApiToUi);
  },

  async create({ title, amount, category, note, monthLabel }) {
    const month = monthLabelToYM(monthLabel);
    const payload = { month, title, amount: Number(amount) || 0 };
    if (category) payload.category = category;
    if (note)     payload.note = note;
    const res = await api.post(BASE, payload);
    return expenseApiToUi(res);
  },

  async update(id, patch) {
    const payload = {};
    if (patch.title !== undefined)    payload.title = patch.title;
    if (patch.amount !== undefined)   payload.amount = Number(patch.amount) || 0;
    if (patch.category !== undefined) payload.category = patch.category;
    if (patch.note !== undefined)     payload.note = patch.note;
    const res = await api.patch(`${BASE}/${encodeURIComponent(id)}`, payload);
    return expenseApiToUi(res);
  },

  async delete(id) {
    return api.delete(`${BASE}/${encodeURIComponent(id)}`);
  },
};
